import { combineReducers } from 'redux';
import tempAnnotations from './stateManager/tempAnnotations/reducer';
import annotationsHidden from './stateManager/annotationsHidden/reducer';
import commentBoxCancelled from './stateManager/commentBoxCancelled/reducer';
import comments from './reducers/comments';
import collaborators from './reducers/collaborators';
import groups from './reducers/groups';
import files from './reducers/files';
import filerrs from './reducers/filerrs';
import current from './reducers/current';
import shareableLink from './reducers/shareableLink';
import team from './reducers/team';
import loading from './reducers/loading';
import errors from './reducers/errors';
import settings from './reducers/settings';

export default combineReducers({
    comments,
    collaborators,
    groups,
    files,
    filerrs,
    current,
    shareableLink,
    team,
    loading,
    errors,
    settings,
    callbacks: (state = {}) => state,
    annotationsHidden,
    tempAnnotations,
    commentBoxCancelled
});
